import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import moment from 'moment';

const WeeklyCalendarHeader = (props) => {
  const {weekDays, headerContent = 'Name'} = props;

  const dayColumnWidth = `calc((100% - 220px) / 7)`;

  return (
    <Box
      sx={{
        display: 'flex',
        borderBottom: '1px solid #ccc',
        background: 'rgb(236, 236, 236)',
        position: 'sticky',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      }}
    >
      <Box
        sx={{
          width: 220,
          minWidth: 220,
          borderRight: '1px solid #ccc',
          py: 1.2,
          pl: 2,
          fontWeight: 700,
          color: 'rgb(0, 0, 0)',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {headerContent}
      </Box>
      {
        weekDays.map((day, i) => {
          const momentDate = moment(day);
          const isToday = momentDate.isSame(moment(), 'day');
          return (
            <Box
              key={i}
              sx={{
                width: dayColumnWidth,
                fontWeight: 600,
                py: 1,
                position: 'relative',
                borderRight: i < 6 ? '1px solid #ccc' : 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                ...(isToday && {
                  backgroundColor: 'rgba(90, 93, 104, 0.2)',
                }),
              }}
            >
              <Box
                sx={{
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                }}
              >
                {momentDate.format('ddd')}
              </Box>
              <Box
                sx={{
                  fontSize: '0.85em',
                  opacity: 0.40,
                }}
              >
                {momentDate.format('MMM D')}
              </Box>
            </Box>
          );
        })
      }
    </Box>
  );
};

WeeklyCalendarHeader.propTypes = {
  weekDays: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerContent: PropTypes.node,
};

export default React.memo(WeeklyCalendarHeader);
